import React from 'react';
import { connect } from 'react-redux';
import { DesktopListing } from './desktop';
import RentIcon from 'assets/svg/sofa-ic.svg';
import SaleIcon from 'assets/svg/key-ic.svg';
import CommercialIcon from 'assets/svg/town-ic.svg';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { MobileListings } from './mobile';
import { State } from 'store/state';
import { agentOfficePageBulletinByDealTypeAndMarketplaceSelector } from 'store/state/domainData/selectors/officeById';
import { IAgentOfficeBulletin } from 'utils/entities';
import { EventProps, PageDetails } from 'screens/AgentOfficePages/types';


export type AgentOfficeBulletinList = Record<TabType, IAgentOfficeBulletin[]>;
export interface ListingProps {
  bulletinsDict: AgentOfficeBulletinList;
  pageDetails?: PageDetails;
  onCarouselScroll?: (props: EventProps) => void;
}

export enum TabType {
  Sale = 'sale',
  Rent = 'rent',
  CommercialSale = 'commercialSale',
  CommercialRent = 'commercialRent',
}

export const tabsIcons = {
  [TabType.Sale]: <SaleIcon />,
  [TabType.Rent]: <RentIcon />,
  [TabType.CommercialSale]: <CommercialIcon />,
  [TabType.CommercialRent]: <CommercialIcon />,
};

const ListingBase: React.FC<ListingProps> = ({ bulletinsDict, pageDetails }) => {
  const isDesktop = useScreenBreakpoint() > 2;
  if (!bulletinsDict) return null;
  return isDesktop ? <DesktopListing bulletinsDict={bulletinsDict} pageDetails={pageDetails} /> : <MobileListings bulletinsDict={bulletinsDict} pageDetails={pageDetails} />;
};

const mapStateToProps = (state: State) => ({
  bulletinsDict: agentOfficePageBulletinByDealTypeAndMarketplaceSelector(state),
});

export const Listing = connect(mapStateToProps)(ListingBase);
